import { render, staticRenderFns } from "./ProfessionalContent.vue?vue&type=template&id=3b52ba2d"
import script from "./ProfessionalContent.vue?vue&type=script&lang=js"
export * from "./ProfessionalContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports